import { render, staticRenderFns } from "./DownloadBibleDialog.vue?vue&type=template&id=3bfb4d17&scoped=true&"
import script from "./DownloadBibleDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadBibleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb4d17",
  null
  
)

export default component.exports